export const API_URL = 'https://dev.aotdelivery.com/api/front/v1/';
export const WEB_URL = 'https://admin.aotdelivery.com/';

// export const API_URL = 'http://127.0.0.1:8000/api/admin/v1/';
// export const WEB_URL = 'http://localhost:3000/';
